import { defineComponent, computed } from 'vue';
import MapSlash from '../../../../../../../../assets/icons/map-slash.svg.js';
import __vue_component__ from '../../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import { useItineraryGeoSearch } from '../../../../useItineraryGeoSearch.js';
import __vue_component__$1 from '../../../../../../../ui/Icon.vue.js';

var script = defineComponent({
    name: 'PortalMapViewToggle',
    components: {
        ButtonComponent: __vue_component__,
        Icon: __vue_component__$1,
        MapSlash,
    },
    setup() {
        const toggleShowMap = () => {
            useItineraryGeoSearch().toggleShowMap();
        };
        const showMap = computed(() => useItineraryGeoSearch().showMap);
        return { toggleShowMap, showMap };
    },
});

export { script as default };
